import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setEmail("");
    toast.success("Welcome to the Atelier. First dispatch arrives soon.");
  };

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-obsidian">
      <div className="pointer-events-none select-none px-6 pt-16 sm:px-12 lg:px-20">
        <div className="whitespace-nowrap font-display text-[13vw] font-semibold leading-[0.85] tracking-tight text-white/[0.04]">
          ATELIER NORTE
        </div>
      </div>
      <div className="grid gap-12 px-6 pb-10 pt-4 sm:px-12 md:grid-cols-3 lg:px-20">
        <div>
          <p className="eyebrow-label mb-4">The Dispatch</p>
          <p className="mb-5 text-sm font-light leading-relaxed text-smoke">
            New objects, atelier notes, and first access to small batches. One letter a month.
          </p>
          <form onSubmit={subscribe} className="flex border border-white/15">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              placeholder="your@email.com"
              data-testid="newsletter-input"
              className="w-full bg-transparent px-4 py-3 font-mono text-xs tracking-wider text-bone outline-none placeholder:text-faint"
            />
            <button type="submit" data-testid="newsletter-submit" className="shrink-0 bg-vermilion px-5 font-mono text-xs uppercase tracking-[0.2em] text-obsidian transition-colors hover:bg-vermilion-dark">
              Join
            </button>
          </form>
        </div>
        <div>
          <p className="eyebrow-label mb-4">Navigate</p>
          <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.25em] text-smoke">
            <Link to="/shop" className="w-fit transition-colors hover:text-bone">Catalog</Link>
            <Link to="/track" className="w-fit transition-colors hover:text-bone">Track an Order</Link>
            <Link to="/contact" className="w-fit transition-colors hover:text-bone">Concierge</Link>
            <Link to="/admin/login" className="w-fit transition-colors hover:text-brass">Atelier Office</Link>
          </div>
        </div>
        <div>
          <p className="eyebrow-label mb-4">Correspondence</p>
          <p className="text-sm font-light text-smoke">concierge@ateliernorte.com</p>
          <p className="mt-1 text-sm font-light text-smoke">Studio 4, Relic Lane — by appointment</p>
          <div className="mt-6 flex gap-4">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="social-instagram" aria-label="Instagram" className="border border-white/15 p-2.5 text-smoke transition-colors hover:border-vermilion hover:text-vermilion">
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="social-twitter" aria-label="Twitter" className="border border-white/15 p-2.5 text-smoke transition-colors hover:border-vermilion hover:text-vermilion">
              <Twitter size={16} strokeWidth={1.5} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="social-facebook" aria-label="Facebook" className="border border-white/15 p-2.5 text-smoke transition-colors hover:border-vermilion hover:text-vermilion">
              <Facebook size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between border-t border-white/10 px-6 py-5 font-mono text-[10px] uppercase tracking-[0.3em] text-faint sm:px-12 lg:px-20">
        <span>© MMXXVI Atelier Norte</span>
        <span>Objects of Permanence</span>
      </div>
    </footer>
  );
}
